import {createMultiStyleConfigHelpers} from '@chakra-ui/styled-system';

const helpers = createMultiStyleConfigHelpers(['container', 'gridItem']);

/**
 * TeaserTileBlock styles - CF08 & CF09
 * Image Tile Block with 2-Col, 3-Col, 4-Col variants
 */
export const teaserTileBlockStyles = helpers.defineMultiStyleConfig({
  baseStyle: () => ({
    container: {
      width: '100%',
    },
    gridItem: {
      width: '100%',
    },
  }),
  variants: {
    /**
     * 2-Column Layout
     */
    'Image tiles (Repeatable tile rows) - (CF-08) - [2-Col]': (args) => ({
      container: {
        paddingTop: {base: '60px', md: args.component.paddingTop || '120px'},
        paddingBottom: {base: '60px', md: args.component.paddingBottom || '120px'},
        gridTemplateColumns: {base: 'repeat(2, 1fr)', md: 'repeat(2, 1fr)'},
        gap: {base: '20px', md: '40px'},
      },
    }),
    /**
     * 3-Column Layout
     */
    'Image tiles (Repeatable tile rows) - (CF-08) - [3-Col]': (args) => ({
      container: {
        paddingTop: {base: '60px', md: args.component.paddingTop || '120px'},
        paddingBottom: {base: '60px', md: args.component.paddingBottom || '120px'},
        gridTemplateColumns: {base: 'repeat(2, 1fr)', md: 'repeat(3, 1fr)'},
        gap: {base: '20px', md: '40px'},
      },
    }),
    /**
     * 4-Column Layout
     */
    'Image tiles (Repeatable tile rows) - (CF-08) - [4-Col]': (args) => ({
      container: {
        paddingTop: {base: '60px', md: args.component.paddingTop || '120px'},
        paddingBottom: {base: '60px', md: args.component.paddingBottom || '120px'},
        gridTemplateColumns: {base: 'repeat(2, 1fr)', md: 'repeat(4, 1fr)'},
        gap: {base: '20px', md: '40px'},
      },
    }),
  },
});
